﻿import { opaccAjaxPlugin } from './vendor/script/opacc.static.js';

export class MisStatistic {
    constructor() {
        this.misControlsAreaSelector = '[data-mis-controls]';
        this.showBtnSelector = '[data-show-mis-button]';
        this.yearSelectName = 'MIS-Select-Years';
        this.monthFromName = 'MIS-Select-MONTH-FROM';
        this.monthToName = 'MIS-Select-MONTH-TO';
        this.listContainerSelector = '[data-mis-list-container]';
        this.attachEventListener();
    }

    attachEventListener() {
        // get controls area
        const controlsArea = document.querySelector(this.misControlsAreaSelector);

        if(!controlsArea) return;

        controlsArea.addEventListener("click", (e) => {
            if(e.target.closest(this.showBtnSelector)) {
                // on show btn clicked
                this.onShowBtnClicked(e);
            }else {

            }
        });
    }

    getTimePeriod() {
        const timePeriodObj = {};

        // get selected year
        const yearSelect = document.getElementsByName(this.yearSelectName)[0];;
        if(!yearSelect) return;

        // get month from
        const mothFromSelect = document.getElementsByName(this.monthFromName)[0];;
        if(!mothFromSelect) return;

        // get month to
        const mothToSelect = document.getElementsByName(this.monthToName)[0];
        if(!mothToSelect) return;

        timePeriodObj.year = yearSelect.value;
        timePeriodObj.monthFrom = mothFromSelect.value;
        timePeriodObj.monthTo = mothToSelect.value;

        timePeriodObj.monthFromText = mothFromSelect.options[mothFromSelect.selectedIndex].text;
        timePeriodObj.monthToText = mothToSelect.options[mothToSelect.selectedIndex].text;

        return timePeriodObj;
    }

    onShowBtnClicked(e) {
        // get url
        const url = e.target.dataset.url;

        const dataToPass = this.getTimePeriod();
        if(!dataToPass) {
            console.error("Invalid timePeriodObj check getTimePeriod()");
            return;
        }

        opaccAjaxPlugin.fetchAsynPostForm(url, dataToPass, (result) => {
           
            const list = this.clearMisList();

            if(!list) { console.error("Invalid selector in onShowBtnClicked()"); return;}

            list.innerHTML = result;


        });
    }

    clearMisList() {
        // get list
        const list = document.querySelector(this.listContainerSelector);

        if(!list) { console.error("Invalid selector in clearMisList()"); return;}

        while (list.firstChild) {
            list.firstChild.remove()
        }

        return list;
    }
}

